import { getJSON, postJSON } from "../helpers";

export interface NoteAPIResponse {
  relevant_information_for_display: string;
  description: string;
  date_modified_timestamp: number;
  created_by_for_display: string;
  id: string;
}

export function getNotesByOrderId(id: string | number) {
  return getJSON<NoteAPIResponse[]>("/Affinity/Orders/Notes/" + id);
}

export function postNoteByOrderId(id: string | number, content: string) {
  return postJSON<NoteAPIResponse>("/Affinity/Orders/AddNote/" + id, {
    content
  });
}
